import { render, staticRenderFns } from "./GSiteFooter.vue?vue&type=template&id=01ab321e&scoped=true&"
import script from "./GSiteFooter.vue?vue&type=script&lang=ts&"
export * from "./GSiteFooter.vue?vue&type=script&lang=ts&"
import style0 from "./GSiteFooter.vue?vue&type=style&index=0&id=01ab321e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ab321e",
  null
  
)

export default component.exports